import {differenceInDays, isAfter} from 'date-fns';
import {SRDetails} from '../../../../../global/api';
import {ServiceRequestStatusesByDate} from '../constants/service-requests-statuses-by-date';
import {STATUS_VALUES} from '../constants/status';

type ServiceRequestWithPlannedDate = SRDetails & {plannedDate?: string | Date | null};
const DONE_LIKE_STATUSES: ReadonlySet<string> = new Set([STATUS_VALUES.DONE]);

export const getServiceRequestStatusByDate = (
  serviceRequest?: ServiceRequestWithPlannedDate,
): ServiceRequestStatusesByDate | undefined => {
  if (!serviceRequest) return undefined;

  const {statusCode, plannedDate} = serviceRequest;
  if (statusCode && DONE_LIKE_STATUSES.has(statusCode)) {
    return ServiceRequestStatusesByDate.COMPLETED_ON_TIME;
  }

  if (!plannedDate) return undefined;

  const now = new Date();
  const planned = new Date(plannedDate);

  if (statusCode === STATUS_VALUES.EXECUTED && !isAfter(now, planned)) {
    return ServiceRequestStatusesByDate.COMPLETED_NOT_CLOSED;
  }

  if (statusCode !== STATUS_VALUES.EXECUTED && isAfter(now, planned)) {
    return ServiceRequestStatusesByDate.DEADLINE_OVERDUE;
  }

  const daysToDeadline = differenceInDays(planned, now);

  if (
    (statusCode === STATUS_VALUES.READY_TO_PROCESS || statusCode === STATUS_VALUES.IN_PROGRESS) &&
    daysToDeadline > 14
  ) {
    return ServiceRequestStatusesByDate.IN_PROGRESS;
  }

  if (
    statusCode !== STATUS_VALUES.DONE &&
    statusCode !== STATUS_VALUES.EXECUTED &&
    daysToDeadline >= 0 &&
    daysToDeadline < 14
  ) {
    return ServiceRequestStatusesByDate.DEADLINE_SOON;
  }

  return undefined;
};
